import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import statecityService from "./statecityService";

export const getBrands = createAsyncThunk(
  "statecity/get-statecitylist",
  async (thunkAPI) => {
    try {
      return await statecityService.getBrands();
      
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getStates = createAsyncThunk(
  "statecity/get-statecity",
  async (thunkAPI) => {
    try {
      return await statecityService.getStates();
      
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getClusters = createAsyncThunk(
  "statecity/get-clusters",
  async (thunkAPI) => {
    try {
      return await statecityService.getClusters();
      
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getABrand = createAsyncThunk(
  "statecity/get-statecity",
  async (id, thunkAPI) => {
    try {
      return await statecityService.getBrand(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createState = createAsyncThunk(
  "statecity/create-state",
  async (brandData, thunkAPI) => {
    try {
      return await statecityService.createState(brandData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createCluster = createAsyncThunk(
  "statecity/create-cluster",
  async (brandData, thunkAPI) => {
    try {
      return await statecityService.createCluster(brandData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateABrand = createAsyncThunk(
  "statecity/update-state",
  async (brand, thunkAPI) => {
    try {
      return await statecityService.updateBrand(brand);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteABrand = createAsyncThunk(
  "statecity/delete-state",
  async (id, thunkAPI) => {
    try {
      return await statecityService.deleteBrand(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  brands: [],
  statelist: [],
  clusterlist:[],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const statecitySlice = createSlice({
  name: "statecity",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBrands.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBrands.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.brands = action.payload;
      })
      .addCase(getBrands.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getStates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.statelist = action.payload;
      })
      .addCase(getStates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getClusters.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClusters.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.clusterlist = action.payload;
      })
      .addCase(getClusters.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createCluster.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCluster.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdcluster = action.payload;
      })
      .addCase(createCluster.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createState.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createState.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdBrand = action.payload;
      })
      .addCase(createState.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default statecitySlice.reducer;
